<template>
  <div class="title-editor">
    <el-form ref="form" label-width="100px">
      <el-form-item label="上边距">
        <el-slider v-model="currentItem.style.margin_top" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="左右边距">
        <el-slider v-model="currentItem.style.padding" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="标题">
        <el-input v-model="currentItem.title" style="width:300px" placeholder="标题文字" clearable></el-input>
      </el-form-item>
      <el-form-item label="标题居中">
        <el-radio-group v-model="currentItem.position">
          <el-radio label="center">居中</el-radio>
          <el-radio label="left">居左</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="显示右标题">
        <el-radio-group v-model="currentItem.is_show_more">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="右标题">
        <el-input v-model="currentItem.more_text" style="width:300px" placeholder="右标题文字" clearable></el-input>
      </el-form-item>
      <el-form-item label="链接到">
        <div class="link">
          <link-to v-model="currentItem.link"></link-to>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import linkTo from '@/components/link/link'
export default {
  name: 'titleEditor',
  components: {
    linkTo
  },
  computed: {
    currentItem () {
      return this.$store.state.page.currentItem
    }
  }
}
</script>
<style lang="less" scoped>
.title-editor {
  .link {
    height: 36px;
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageEditor/editors/wtitleEditor.vue